module.exports = __webpack_public_path__ + "static/media/ch.269ddab4.svg";